// layout Development Studio - bez menu i stopki

import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { BoxArrowRight } from 'react-bootstrap-icons';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch, reduxActions } from 'store';
import styles from 'theme/components/layouts/DevStudioLayout/DevStudioLayout.module.scss';
import logo from 'assets/logo.svg';
import ChatLauncher from 'components/containers/ChatLauncher';
import DockedChatContainer from 'components/containers/DockedChatContainer';
import HorizontalChatContainer from 'components/containers/HorizontalChatContainer';
import { AssistantInfo } from 'components/containers/ChatBase';

const DevStudioLayout = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { profile, isAuthenticated } = useSelector((state) => state.auth);
  const { isChatDocked, isChatHorizontal, isChatOpen, lastChatModeBeforeClose, devStudioContext } = useSelector((state) => state.chat);

  const withDockedChat = isChatDocked && isChatOpen;
  const withHorizontalChat = isChatHorizontal && isChatOpen;
  const devStudioChatParams: Record<string, string> = {
    ...(devStudioContext.processId ? { context_process_id: devStudioContext.processId } : {}),
    ...(devStudioContext.workflowId ? { context_workflow_id: devStudioContext.workflowId } : {})
  };
  const devStudioAssistants: AssistantInfo[] = [
    {
      name: 'WiseB2B - Workflow',
      symbol: 'wiseb2bWorkflow',
      description: 'Asystent AI do edycji procesów i workflow',
      isDefault: true,
      canAttachFiles: false
    }
  ];

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
      return;
    }
    if (profile && profile.role !== 'ROLE_ADMIN') {
      navigate('/');
    }
  }, [profile, isAuthenticated]);

  // Ustaw tryb docked jako domyślny przy wejściu do DevStudio,
  // tylko jeśli chat nie był wcześniej otwarty w innym trybie
  useEffect(() => {
    if (!isChatOpen && !lastChatModeBeforeClose) {
      dispatch(reduxActions.setChatModeDirect('docked'));
    }
  }, []);

  const handleGoToPanel = () => {
    // Przekierowanie do panelu administracyjnego
    navigate('/managment_panel');
  };

  const handleGoToHome = () => {
    // Przekierowanie do głównej strony aplikacji
    navigate('/');
  };

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Layouts-DevStudioLayout',
        {
          [styles.withDockedChat]: withDockedChat,
          [styles.withHorizontalChat]: withHorizontalChat
        }
      )}>
      <div className={styles.mainWrapper}>
        <div className={styles.headerAndContent}>
          <header className={styles.header}>
            <div className={styles.headerContent}>
              <div className={styles.logoSection}>
                <img src={logo} alt="WiseB2B" className={styles.logo} />
                <div className={styles.divider} />
                <span className={styles.title}>{t('Development Studio')}</span>
              </div>
              <div className={styles.headerActions}>
                <ChatLauncher openLabel={t('Modyfikuj z AI')} closeLabel={t('Zamknij AI')} extraUrlParameters={devStudioChatParams} availableAssistants={devStudioAssistants} hideQuickActions />
                <button className={styles.exitButton} onClick={handleGoToPanel}>
                  <span>{t('Panel administracyjny')}</span>
                </button>
                <button className={styles.exitButton} onClick={handleGoToHome}>
                  <span>{t('Wróć na stronę')}</span>
                  <BoxArrowRight size={20} />
                </button>
              </div>
            </div>
          </header>
          <main className={styles.mainContent}>
            {withHorizontalChat && <HorizontalChatContainer extraUrlParameters={devStudioChatParams} availableAssistants={devStudioAssistants} hideQuickActions />}
            <Outlet />
          </main>
        </div>
        {withDockedChat && <DockedChatContainer extraUrlParameters={devStudioChatParams} availableAssistants={devStudioAssistants} hideQuickActions />}
      </div>
    </div>
  );
};

export default DevStudioLayout;
